var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-layout',{attrs:{"centered":true}},[_c('v-img',{staticClass:"home-background",attrs:{"src":require('@/assets/images/home/ikone-background.jpg')}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }